function MediaObserver (els) {
    let observer = null;

    const fn = {
        init () {
            observer = new window.IntersectionObserver(handlers.onIntersect, {
                root: null,
                rootMargin: '200%',
                threshold: 0
            })

            els.forEach(el => observer.observe(el));
        }
    }

    const handlers = {
        onIntersect (entries) {
            entries.forEach(entry => {
                const entryWidth = entry.boundingClientRect.width + 'px'
                const targetEl = entry.target

                if (entry.isIntersecting) {
                    targetEl.sizes = entryWidth
                    targetEl.src = targetEl.dataset.src
                    targetEl.srcset = targetEl.dataset.srcset

                    observer.unobserve(targetEl);
                }
            });
        }
    }

    fn.init()
}

export default function LazyMedia () {
    const mediaSelector = '.media__obj--lazy.media__obj--img';
    const mediaEls = document.querySelectorAll(mediaSelector);
    if (!mediaEls) { return }

    return new MediaObserver(mediaEls);
}
